module.exports = __webpack_public_path__ + "img/x.c8cfd8d0.svg";